import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { BackButton } from "src/common/components/BackButton";
import { useAccess } from "src/hooks/useAccess.hook";
import sidebarConfig from "src/layouts/dashboard/SidebarConfig";
import { alertSlice } from "src/store/alert/alert.slice";
import { FEATURE } from "src/util/enums";
import Page from "../Page";
import { PaymentGatewayForm } from "./PaymentGatewayForm";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useAuth } from "src/hooks/useAuth.hook";

export const PaymentGateway = () => {
  const navigate = useNavigate();
  const isCreatePaymentGateway = useMatch("/payment-gateways/new");
  const dispatch = useDispatch();
  const { teamId } = useSelectedTeam();
  const { user } = useAuth();
  const hasFinanceConfigAccess = useAccess(FEATURE.FINANCE, "FA");
  const paymentGatewayReadOnly = useAccess(FEATURE.PAYMENTGATEWAY, "R");
  const paymentGatewayNotAuthorized = useAccess(FEATURE.PAYMENTGATEWAY, "N");
  const paymentGatewayCreateAccess = useAccess(FEATURE.PAYMENTGATEWAY, "C");
  
  // Check if Grand Parent Company is selected (teamId matches user.company.id)
  const isGrandParentCompanySelected = useMemo(() => {
    return String(teamId) === String(user?.company?.id);
  }, [teamId, user?.company?.id]);
  
  const isReadOnly = hasFinanceConfigAccess && paymentGatewayReadOnly;
  const notAuthorized = !hasFinanceConfigAccess || (!isGrandParentCompanySelected && paymentGatewayNotAuthorized);
  // For GP users with Finance FA access, allow create even if PaymentGateway create access is not in backend
  const createAccess = hasFinanceConfigAccess && isGrandParentCompanySelected;

  useEffect(() => {
    if (
      (isCreatePaymentGateway && !createAccess) ||
      (!isCreatePaymentGateway && notAuthorized)
    ) {
      dispatch(
        alertSlice.actions.setAlert({ open: true, message: "Not Authorized" })
      );
      navigate("/dashboard");
    }
  }, [dispatch, isCreatePaymentGateway, createAccess, navigate, notAuthorized]);

  return (
    <Page>
      <BackButton
        text={
          isCreatePaymentGateway
            ? "Create Payment Gateway"
            : isReadOnly
            ? "Payment Gateway Details"
            : "Edit Payment Gateway Details"
        }
        path="/payment-gateways"
      />
      <PaymentGatewayForm />
    </Page>
  );
};

